export { default as RootNavigator } from "./Root";
